import { render, staticRenderFns } from "./ArgentinaLotteryStream.vue?vue&type=template&id=3088f5e2&scoped=true&"
import script from "./ArgentinaLotteryStream.vue?vue&type=script&lang=js&"
export * from "./ArgentinaLotteryStream.vue?vue&type=script&lang=js&"
import style0 from "./ArgentinaLotteryStream.vue?vue&type=style&index=0&id=3088f5e2&scoped=true&lang=scss&"
import style1 from "./ArgentinaLotteryStream.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3088f5e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VImg,VResponsive,VRow})
